/* MOG MINTS — behaviour for the product template.
   Lifted verbatim from the page-level script in shop.html at the port, 23 Aug.
   Only two things changed: the mint-sequence frame path (Shopify assets are
   flat, so assets/mint/seq/ became a 'mintseq-' prefix and the base URL is
   injected by Liquid), and other asset paths flattened the same way.

   ⚠ Every module in here guards on its own root element, so loading it on a
   page that lacks that markup is a no-op rather than an error. */
/* ---- the buy module ------------------------------------------------------
   NOT ONE FIGURE IN HERE IS CALCULATED. This block used to hold BASE, BUNDLE
   and SUB and derive every price on the page from them, which is how two files
   ended up holding one price. On Shopify that job belongs to variants and
   selling plans, so the arithmetic is gone and what remains is a renderer: it
   reads the table Liquid wrote into [data-buy-data] and puts those strings on
   screen. The markup and the class toggles are untouched, per the porting note
   that used to sit here.

   Money arrives already formatted by the `money` filter, so currency format
   stays a store setting and this file never sees a number it could round.

   THE SUBSCRIBE PRICE IS THE PLAN'S OWN ALLOCATION PRICE. If a rendered
   subscribe price disagrees with the agreed table, the subscription app is
   configured wrong. Do not correct it here.

   ⚠ The cart field is found BY NAME, never by id. Setting it through the
   subscription app's own DOM nodes is known to break. */
(function(){
  /* THE CARD'S ROOT (2026-10-14). The product page's buy section is variant D since decision 129 and is found by
     [data-buy-root]: it cannot carry .prod, which base.css paints black and lays out as the old two-column stage.
     The old card's section is still .prod. One root, the first found, as before.
     Later the same day the home page's buy section became the same product-buy (Ashot: "Yes, match the home page"), and
     layout/theme.liquid loads this file on the home page too, after index.js; the .prod card renders nowhere now. */
  var root = document.querySelector('[data-buy-root]') || document.querySelector('.prod'); if (!root) return;
  var tag  = root.querySelector('[data-buy-data]'); if (!tag) return;
  var DATA; try { DATA = JSON.parse(tag.textContent); } catch (e) { return; }
  if (!DATA || !DATA.variants || !DATA.variants.length) return;

  var byId = {};
  DATA.variants.forEach(function(v){ byId[String(v.id)] = v; });

  /* mirrored figures live outside .prod too (closing block, sticky bar) */
  var setAll = function(sel, txt){
    [].forEach.call(document.querySelectorAll(sel), function(el){ el.textContent = txt; });
  };
  var set = function(sel, txt){
    var el = root.querySelector(sel); if (el) el.textContent = txt;
  };
  function esc(s){
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cadenceOf(name){
    var l = String(name == null ? '' : name), i = l.toLowerCase().indexOf('every');
    return i < 0 ? l : 'Every ' + l.slice(i + 5).split('(')[0].trim();
  }
  /* the plan's cadence inside a sentence: "Deliver every 1 month" reads "every month", "every 2 months" stays */
  function everyOf(name){
    var l = String(name == null ? '' : name).toLowerCase(), i = l.indexOf('every');
    if (i < 0) return 'per delivery';
    return 'every ' + l.slice(i + 5).split('(')[0].trim().replace(/^1\s+/, '');
  }
  function read(name){
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }
  /* the cadence is a select since 2026-10-07 (Ashot's spec: "choose delivery frequency"); the radios it
     replaced are still read, so an older card keeps working */
  function freq(){
    var s = root.querySelector('select[name="pfreq"]');
    return s ? s.value : read('pfreq');
  }
  function currentVariant(){
    var id = read('size');
    return (id && byId[id]) || DATA.variants[0];
  }
  /* the chosen cadence, or the first plan the variant offers. A variant with no
     plans returns null and every subscribe branch below goes quiet. */
  function planFor(v){
    if (!v || !v.plans || !v.plans.length) return null;
    var want = freq();
    for (var i = 0; i < v.plans.length; i++){
      if (String(v.plans[i].id) === String(want)) return v.plans[i];
    }
    return v.plans[0];
  }
  /* the frequency options follow the pack. The plans are the store's and shared across sizes, so the ids
     match and the choice survives a size change; a size with fewer plans simply offers fewer. */
  function options(v){
    var s = root.querySelector('select[name="pfreq"]'); if (!s) return;
    var keep = s.value, html = '';
    (v.plans || []).forEach(function(p){
      html += '<option value="' + esc(p.id) + '"' + (String(p.id) === String(keep) ? ' selected' : '') + '>' + esc(p.name) + '</option>';
    });
    if (s.innerHTML !== html) s.innerHTML = html;
  }

  function render(){
    var v = currentVariant(); if (!v) return;
    options(v);
    var sub  = read('ptype') === 'sub';
    var plan = planFor(v);
    /* A SIZE WITH NO PLAN (the 240 pack today, 2026-09-15): the subscribe row and its panel go
       and One time takes the selection, instead of a row with an empty price. */
    var noPlan = !plan;
    root.classList.toggle('no-plans', noPlan);
    if (noPlan && sub) {
      var onceIn = root.querySelector('input[name="ptype"][value="once"]');
      if (onceIn) { onceIn.checked = true; }
      sub = false;
    }
    var now  = (sub && plan) ? plan.price : v.price;

    setAll('[data-total]', now);
    /* the price rides on the Add to cart button (Ashot's mockup, 2026-10-07) */
    setAll('[data-cart]', '• ' + now);
    /* per-mint is the variant's own, so it can never drift from the price above it */
    if (v.each > 0) setAll('[data-each]', v.each + '¢ a mint');
    /* guarded: the spec grid states 60 mints PER TIN, which does not move with
       quantity, so there may be no [data-count] on the page at all. Unguarded
       this throws and takes every price on the section down with it. */
    setAll('[data-count]', (v.tins * 60) + ' mints' + (v.tins > 1 ? ' · ' + v.tins + ' tins' : ''));

    /* the struck price is a REAL comparison every time: against the same order
       undiscounted when buying once, against the one-time price when
       subscribing. Empty when nothing is saved, and .save:empty plus this blank
       string keep the flags off the page entirely. */
    set('[data-was]', sub && plan ? v.price : (v.compare || ''));
    set('[data-subsave]', plan && plan.pct > 0 ? 'Save ' + plan.pct + '%' : '');
    setAll('[data-subpct]', plan ? plan.pct + '%' : '');

    /* the two purchase rows always quote the CURRENT pack, so switching to
       subscribe compares like with like instead of against a single tin */
    set('[data-ponce]', v.price);
    /* the One-time row's per-serving line on the product page's card (variant D, decision 129): the variant's own
       figure from the table, the one its pack row prints. No other card carries the hook. */
    set('[data-ponce-serving]', v.serving ? v.serving + ' per serving' : '');
    setAll('[data-hprice]', v.price);
    setAll('[data-hwas]', v.compare || '');
    set('[data-psub]',  plan ? plan.price : '');
    setAll('[data-was-sub]', v.price);

    /* THE SUBSCRIPTION LINES (2026-10-07, Ashot's spec). The deal pack's plan carries the renewal price
       of the smaller pack it becomes (Liquid looked it up from settings.sub_renew_tins); every other
       pack renews as itself. The words follow: "today" against "per delivery", and "on your first order"
       only where a renewal differs. Nothing here is a number the page did not already hold. */
    var renew = !!(plan && plan.renew && DATA.renew_tins > 0);
    set('[data-psub-when]', renew ? 'today' : 'per delivery');
    var rn = root.querySelector('[data-sub-renew]');
    if (rn) {
      rn.hidden = !renew;
      /* one sentence since 2026-10-09, Ashot's words ("3 tins on the first order, then 2 tins for ... every month"),
         the same one the Liquid prints; the price is the renewal pack's own plan price, read, never typed */
      if (renew) {
        set('[data-sub-line]', v.tins + (v.tins === 1 ? ' tin' : ' tins') + ' on the first order, then ' + DATA.renew_tins +
          (DATA.renew_tins === 1 ? ' tin' : ' tins') + ' for ' + plan.renew + ' ' + everyOf(plan.name));
      }
    }
    /* the cadence, printed from the plan's name the way the Liquid prints it ("Deliver every 1 month" reads "Every 1 month") */
    var cad = root.querySelector('[data-cadence]');
    if (cad && plan) cad.textContent = cadenceOf(plan.name);

    /* THE VARIANT FIELD (2026-09-30). One hidden input[name="id"], kept in step with the checked size.
       The size cards used to BE the id field, four radios sharing the name. The add to cart post was
       fine with that, a browser serialises the checked one. Shopify's wallet script is not:
       portable-wallets reads form.elements.namedItem("id") and, handed a radio group, takes .item(0),
       the first radio, always. So Apple Pay and Shop Pay on the product page sold the Solo whatever
       size was chosen, and a customer caught it. The wallet re-reads the form when a value ATTRIBUTE
       changes (its MutationObserver filters on "value"), so the attribute is set with the property.
       The home card has no form and no such field, and this block is a no-op there. */
    var idIn = root.querySelector('input[type="hidden"][name="id"]');
    if (idIn && idIn.value !== String(v.id)) {
      idIn.value = String(v.id);
      idIn.setAttribute('value', String(v.id));
      idIn.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* THE CART FIELD. By name, always. */
    var sp = root.querySelector('[name="selling_plan"]');
    if (sp) sp.value = (sub && plan) ? plan.id : '';
  }

  root.addEventListener('change', function(e){
    if (e.target.name === 'size' || e.target.name === 'ptype') render();
    /* reaching for a cadence IS choosing to subscribe. Without this you can set
       "every 2 months" while One-time stays selected, and the box argues with
       itself. */
    if (e.target.name === 'pfreq') {
      var s = root.querySelector('input[name="ptype"][value="sub"]');
      if (s && !s.checked) { s.checked = true; }
      render();
    }
  });

  /* ADD TO CART. The home page's control is an anchor to the product page, which
     is a working route with scripting off; here we intercept it and post to the
     cart instead. The product page's control is a real submit inside
     {% form 'product' %} and needs no help, so it is left alone unless the
     drawer is present to catch it. */
  var addLink = root.querySelector('[data-add]');
  if (addLink) {
    addLink.addEventListener('click', function(ev){
      var v = currentVariant(); if (!v) return;   /* no sold-out gate in the theme (2026-09-14) */
      ev.preventDefault();
      var body = { items: [{ id: v.id, quantity: 1 }] };
      var sp = root.querySelector('[name="selling_plan"]');
      if (sp && sp.value) body.items[0].selling_plan = Number(sp.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        /* never report a success we did not get: a non-2xx here is a real
           failure and the reader has to end up somewhere that works. */
        if (!r.ok) { window.location.href = addLink.getAttribute('href'); return null; }
        return r.json();
      }).then(function(data){
        if (!data) return;
        document.dispatchEvent(new CustomEvent('mog:cart:added', { detail: data }));
      }).catch(function(){
        window.location.href = addLink.getAttribute('href');
      });
    });
  }

  render();
})();

/* MORE PAYMENT OPTIONS OPENS THE DRAWER (Ashot, 2026-09-30: "have more payment options open the
   cart drawer not the checkout page"). Shopify's product page button shows ONE wallet, its own pick
   per shopper (Shop Pay first on every device tested), and its "More payment options" link builds a
   checkout for the single line. The full wallet row, Apple Pay, Shop Pay, PayPal, Google Pay, Venmo,
   sits under Checkout in the drawer since today, so the link now does what Add to cart does: adds
   the chosen size and opens the drawer, where every wallet is one tap away.
   How: the link is in the light DOM (the element more-payment-options-link appends a plain anchor,
   href="#", with Shopify's handler on .onclick), so a capturing listener on the form pre-empts it,
   and stopPropagation in the capture phase keeps the event from ever reaching the anchor. Space on
   the link calls anchor.click() inside Shopify's code and Enter activates the anchor, so both arrive
   here as a click as well. The Add to cart button is a real submit: cart.js intercepts it, posts the
   form and opens the drawer; without cart.js the browser posts it and lands on the cart page, which
   carries the same wallet row. If Shopify ever moves the link into a shadow root, this listener
   simply never matches and the link goes back to building a checkout.
   CDN note (2026-09-30): Shopify's CDN cached the previous body of this file under the first version
   key of this change, so it was re-saved once to take a fresh key. Not a behaviour change. */
(function(){
  var pform = document.getElementById('mog-buy'); if (!pform) return;
  pform.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('#more-payment-options-link, more-payment-options-link')) return;
    e.preventDefault();
    e.stopPropagation();
    /* by its name, the way cart.js finds it (2026-10-14): the product page's button is .pdp-cta since variant D */
    var cta = pform.querySelector('[name="add"]');
    if (cta) cta.click();
  }, true);
})();

/* ---- GALLERY-JS-START ---- the product gallery. Same tablist contract as the
   question groups below. The build cuts on these markers to lift it onto
   shop.html, so the two pages cannot end up with different gallery behaviour. */
(function(){
  var wrap = document.getElementById('stage'); if(!wrap) return;
  var shots = [].slice.call(wrap.children);
  var tabs  = [].slice.call(document.querySelectorAll('.stage__rail button'));
  var n     = document.getElementById('stage-n');
  function show(i, focus){
    shots.forEach(function(s, k){ s.hidden = k !== i; });
    tabs.forEach(function(t, k){
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
      if (k === i && focus) t.focus();
    });
    if (n) n.textContent = ('0' + (i + 1)).slice(-2);
  }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(+t.dataset.go); });
  });
  document.querySelector('.stage__rail').addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement); if (i < 0) return;
    var k = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') k = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') k = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') k = 0;
    else if (e.key === 'End') k = tabs.length - 1;
    if (k === null) return;
    e.preventDefault(); show(k, true);
  });
})();
/* ---- GALLERY-JS-END ---- */

/* ---- the mint, coming apart ------------------------------------------------
   Scroll picks a FRACTIONAL frame out of the sequence and paints it to a canvas:
   frame n, then frame n+1 over it at the fraction between them. The interpolation
   is what makes 121 discrete frames read as continuous motion instead of stepping
   every ~10px of scroll.
   ⚠ CANVAS, NOT <img> SRC SWAPPING. The first version of this held two stacked
   <img>s and cross-faded them by opacity, and it flickered: assigning .src does not
   repaint synchronously even when the image is cached, so on the frame where the
   pair advanced, the base layer could still be showing the PREVIOUS image at full
   opacity while the new top layer sat at zero — one paint of going backwards, every
   time the index moved. drawImage has nothing to swap and nothing to wait for.
   ⚠ NO <video> either. Scrubbing one means driving currentTime, and a browser will
   refuse seeks on a video that has never played, suspends media in a background tab,
   and adds seek latency of its own.
   ⚠ EVERY FRAME IS DECODED BEFORE THE SEQUENCE IS DRIVEN — decode(), not just load,
   so the first pass cannot stall on a decode. Until they are all in, the poster
   <img> underneath simply holds.
   ⚠ The wires are drawn here rather than authored in the markup: the cards are
   positioned against the pin and the pieces against the frame box, so there is no
   one coordinate system both ends live in. Each is an elbow — out of the card
   horizontally, one bend, then straight to its piece — and the bend sits the same
   distance from the card on both sides, so the columns mirror.
   ⚠ Reads are throttled through rAF and the handler returns early when the section
   is off screen. Nothing in draw() measures the DOM: the wire geometry is cached on
   resize, so driving the scrub never forces a layout. */
(function(){
  var sec = document.getElementById('boom'); if (!sec) return;
  var stage = sec.querySelector('.boom__stage');
  var pin   = sec.querySelector('.boom__pin');
  var mint  = sec.querySelector('.boom__mint');
  var svg   = sec.querySelector('.boom__wires');
  var cv    = sec.querySelector('.boom__f--c');
  var post  = sec.querySelector('.boom__f:not(.boom__f--c)');
  var cards = [].slice.call(sec.querySelectorAll('.boom__card'));
  if (!stage || !pin || !mint || !cv) return;

  var N = parseInt(mint.getAttribute('data-frames'), 10) || 121;
  var CW = cv.width, CH = cv.height;
  /* ⚠ alpha:true, AND IT MATTERS. This was {alpha:false} while the frames carried
     a baked-in black ground: an opaque context is cheaper to composite and there
     was nothing transparent to preserve. The frames are cut out now, so an opaque
     context paints their transparent regions BLACK and the sequence sits in a
     black rectangle on the band. The two settings are a pair with the frames —
     re-ground the frames and this goes back to false. */
  var ctx = cv.getContext('2d', {alpha:true});
  var src = function(i){ return (window.MOG_SEQ_BASE||'') + 'mintseq-m_' + (i < 100 ? (i < 10 ? '00' : '0') : '') + i + '.webp'; };

  /* ⚠ THESE READ AGAINST THE LEAD-IN, NOT THE BARE TRAVEL — see draw(). p now
     spans (LEAD * viewport + travel), so the same number means a later moment in
     scroll than it did before LEAD existed. Re-tune the pair together or the
     break drifts. */
  var BREAK0 = 0.02, BREAK1 = 0.56;       /* where the break runs in the travel */
  /* Measured on a 1000px viewport: the break now finishes with the mint centred
     ~736px down the screen — fully in view, and roughly 400px of scroll sooner
     than it used to land. Cards open at ~59% through the break and the last one
     arrives just after it closes. */
  var CARD0  = 0.34, CARD_STEP = 0.026;
  /* ⚠ THE SCRUB USED TO START TOO LATE TO SEE. p was 0 until the section's TOP
     reached the top of the viewport — but the mint sits 545px down the section,
     so it had already been fully on screen for ~455px of scroll by then, sitting
     on frame 1 doing nothing. LEAD moves the zero point up the page by this much
     of a viewport, so the break begins as the mint arrives rather than long after.
     The END of the scrub is unchanged, so the section still finishes where it did. */
  var LEAD   = 0.42;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var imgs = new Array(N), got = 0, ready = false;
  var wires = [], ticking = false, wireOn = false, lastP = -1, lastKey = '';

  /* ⚠ SEED THE CANVAS BEFORE REVEALING IT. draw() returns early while the section
     is off screen, and it almost always is when the frames finish loading — so
     revealing first put an unpainted, opaque black canvas over the poster and the
     mint vanished until you scrolled into the section. Paint frame 1, then show. */
  function go(){
    if (ready) return;
    ready = true; lastP = -1; lastKey = '';
    paintFrame(0);
    cv.classList.add('is-on');
    /* ⚠ HIDE THE POSTER ONCE THE CANVAS IS UP. It used to be safe to leave it: the
       frames were opaque, so the canvas covered it completely. The frames carry
       alpha now, so the poster — frame 1, the WHOLE mint — showed through the gaps
       between the pieces for the entire sequence. Kept in the DOM rather than
       removed so it is still what renders with scripting off. */
    if (post) post.style.visibility = 'hidden';
    draw();
  }
  /* ⚠ READINESS IS GATED ON load, NOT ON decode(). It was gated on decode() and
     that hung: in a hidden document — a tab opened in the background, which is
     most of them — the promise simply never settles, so the sequence never came up
     and the poster held forever. decode() is still called, because a decoded frame
     costs nothing at first paint, but nothing waits on it.
     ⚠ And a stalled image cannot hold the whole sequence hostage either: whatever
     has arrived after 10s is enough to start, and paintFrame falls back to the
     nearest frame it actually has. */
  function load(i){
    var im = new Image();
    im.decoding = 'async';
    var done = function(){ if (++got === N) go(); };
    im.onerror = done;
    im.onload = function(){
      imgs[i - 1] = im;
      done();
      if (im.decode) { im.decode().catch(function(){}); }
    };
    im.src = src(i);
  }
  for (var i = 1; i <= N; i++) load(i);
  setTimeout(function(){ if (imgs[0]) go(); }, 10000);

  function paintFrame(t){
    if (!ready) return;
    var f = 1 + t * (N - 1);
    var i0 = Math.floor(f), fr = f - i0;
    if (i0 >= N) { i0 = N; fr = 0; }
    var i1 = i0 + 1 > N ? N : i0 + 1;
    var key = i0 + ':' + Math.round(fr * 64);
    if (key === lastKey) return;
    lastKey = key;
    /* fall back to the nearest frame that has actually arrived */
    var a = imgs[i0 - 1];
    for (var k = i0 - 1; !a && k >= 1; k--) a = imgs[k - 1];
    for (var k2 = i0 + 1; !a && k2 <= N; k2++) a = imgs[k2 - 1];
    var b = imgs[i1 - 1];
    if (!a) return;
    /* ⚠ CLEAR FIRST. The frames carry an alpha channel now, so nothing in them
       paints over what is already on the canvas — without this every frame
       accumulates on the last and the mint smears into a solid mass. It was
       genuinely unnecessary while the frames were opaque on a baked-in ground;
       it became mandatory the moment that ground was cut out. */
    ctx.clearRect(0, 0, CW, CH);
    ctx.globalAlpha = 1;
    ctx.drawImage(a, 0, 0, CW, CH);
    if (b && b !== a && fr > 0.004) {
      ctx.globalAlpha = fr;
      ctx.drawImage(b, 0, 0, CW, CH);
      ctx.globalAlpha = 1;
    }
  }

  /* the badges carry no geometry — a number sits on its own piece — so all this
     does is key each card and badge to its REVEAL position rather than its place
     in the markup */
  /* one <path> and one dot per card, so a wire can never outnumber its card.
     --i is the REVEAL position, from data-seq, not the place in the markup. */
  function build(){
    if (!svg) return;
    svg.innerHTML = '';
    wires = cards.map(function(card, i){
      var q = parseInt(card.getAttribute('data-seq'), 10);
      if (isNaN(q)) q = i;
      card.style.setProperty('--i', q);
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('class', 'boom__w'); p.setAttribute('pathLength', '1');
      p.style.setProperty('--i', q);
      var d = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      d.setAttribute('class', 'boom__wd');
      d.style.setProperty('--i', q);
      svg.appendChild(p); svg.appendChild(d);
      return {path:p, dot:d, card:card, seq:q,
              cx: parseFloat(card.getAttribute('data-cx')),
              cy: parseFloat(card.getAttribute('data-cy')),
              /* the piece's own radius, so the pointer lands ON it whatever its
                 size — a flat stop distance left the B12 sliver's dot in open black */
              pr: parseFloat(card.getAttribute('data-r')) || 0.08,
              left: card.classList.contains('boom__card--l')};
    });
  }

  /* everything the wires need that only changes on resize */
  function measure(){
    if (!svg || !wires.length) return;
    var pr = pin.getBoundingClientRect(), mr = mint.getBoundingClientRect();
    if (!pr.width || !mr.width) return;
    svg.setAttribute('viewBox', '0 0 ' + Math.round(pr.width) + ' ' + Math.round(pr.height));
    var bend = Math.max(26, Math.min(64, pr.width * 0.042));
    /* the pointer scales with the pin so it holds its weight at every width */
    var dotR = Math.max(4, Math.min(7.5, pr.width * 0.0039));
    wires.forEach(function(w){
      w.dot.setAttribute('r', dotR.toFixed(2));
      var cr = w.card.getBoundingClientRect();
      var x1 = (w.left ? cr.right : cr.left) - pr.left;
      var y1 = cr.top + cr.height / 2 - pr.top;
      var bx = x1 + (w.left ? bend : -bend);
      var px = mr.left - pr.left + w.cx * mr.width;
      var py = mr.top - pr.top + w.cy * mr.height;
      var vx = px - bx, vy = py - y1, len = Math.sqrt(vx * vx + vy * vy) || 1;
      var t = Math.max(0, len - mr.width * w.pr * 0.55) / len;
      var ex = bx + vx * t, ey = y1 + vy * t;
      w.path.setAttribute('d', 'M' + x1.toFixed(1) + ',' + y1.toFixed(1) +
                               'H' + bx.toFixed(1) +
                               'L' + ex.toFixed(1) + ',' + ey.toFixed(1));
      w.dot.setAttribute('cx', ex.toFixed(1)); w.dot.setAttribute('cy', ey.toFixed(1));
    });
  }

  build();

  if (reduce) {
    cards.forEach(function(c){ c.classList.add('is-on'); });
    if (svg) svg.classList.add('is-on');
    measure();
    return;
  }

  function draw(){
    var r = stage.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    var travel = r.height - innerHeight;
    /* Pinned (desktop): progress is how far the section has travelled under the
       pin. Unpinned (≤1000px, and any viewport taller than the section): there is
       no travel to divide by, so scrub against its own pass up the screen — 0 when
       its top is at the bottom of the viewport, 1 when its bottom reaches the top.
       Monotonic at both ends, and no branch that can stick. */
    var lead = innerHeight * LEAD;
    var p = travel > 0 ? ((lead - r.top) / (travel + lead))
                       : ((innerHeight - r.top) / (innerHeight + r.height));
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    if (p === lastP) return;
    lastP = p;

    var t = (p - BREAK0) / (BREAK1 - BREAK0);
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    paintFrame(t);

    for (var i = 0; i < cards.length; i++) {
      var q = parseInt(cards[i].getAttribute('data-seq'), 10);
      cards[i].classList.toggle('is-on', p >= CARD0 + (isNaN(q) ? i : q) * CARD_STEP);
    }
    var w = p >= CARD0;
    if (svg && w !== wireOn) { wireOn = w; svg.classList.toggle('is-on', w); }
  }
  function onScroll(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){ ticking = false; draw(); });
  }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', function(){ measure(); lastP = -1; onScroll(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  measure();
  draw();
})();

/* The four systems. A real tablist: click, and arrow/Home/End keys move between
   systems with roving tabindex, because a row of <button role="tab"> that only
   answers the mouse is a tablist in name only. */
(function(){
  var nav = document.querySelector('.sysnav'); if(!nav) return;
  var tabs = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.pane'));

  function show(sys, focus){
    tabs.forEach(function(t){
      var on = t.dataset.sys === sys;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.sys === sys;
      p.hidden = !on;
      /* Restart the entrance AND every diagram animation inside the pane.
         The panes are stacked in one grid cell and hidden with visibility, so
         they never leave the render tree — which means their animations do NOT
         restart on their own the way they did under display:none.
         Dropping the pane out of the render tree for one frame and putting it
         straight back cancels and re-starts the whole subtree. Toggling
         p.style.animation only ever restarted the pane's own entrance, not the
         curves, the climbing ball or the gears.
         The container does not flinch while this happens: the other three panes
         are still laid out in the same cell holding the height, and no paint
         occurs inside a single task. */
      if (on){ p.style.display = 'none'; void p.offsetWidth; p.style.display = ''; }
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.sys); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.sys, true);
  });
})();

/* ---- GALLERY-JS-START ---- the product gallery. Same tablist contract as the
   question groups below. The build cuts on these markers to lift it onto
   shop.html, so the two pages cannot end up with different gallery behaviour. */
(function(){
  var wrap = document.getElementById('stage'); if(!wrap) return;
  var shots = [].slice.call(wrap.children);
  var tabs  = [].slice.call(document.querySelectorAll('.stage__rail button'));
  var n     = document.getElementById('stage-n');
  function show(i, focus){
    shots.forEach(function(s, k){ s.hidden = k !== i; });
    tabs.forEach(function(t, k){
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
      if (k === i && focus) t.focus();
    });
    if (n) n.textContent = ('0' + (i + 1)).slice(-2);
  }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(+t.dataset.go); });
  });
  document.querySelector('.stage__rail').addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement); if (i < 0) return;
    var k = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') k = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') k = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') k = 0;
    else if (e.key === 'End') k = tabs.length - 1;
    if (k === null) return;
    e.preventDefault(); show(k, true);
  });
})();
/* ---- GALLERY-JS-END ---- */

/* The question groups. Same tablist contract as the four systems — the two could
   share a factory, and if a third tablist ever lands on this page they should.
   Two are not enough to justify the indirection; three would be. */
(function(){
  var nav = document.querySelector('.faq__nav'); if(!nav) return;
  /* ONE BINDING PER TABLIST (2026-10-14). product.js carries this module twice, and since the home page's buy section became
     product-buy (decision 129) the home page loads product.js beside this file, so the FAQ's tablist was bound twice on the
     product page and three times on the home page. Every binding answers the same arrow key in turn, so one press moved the
     choice two tabs on the product page and all the way round to where it started on the home page (measured on the local
     faithful pages). Whichever copy runs first binds the tablist and marks it; every later copy stands down. */
  if (nav.hasAttribute('data-tabs-bound')) return; nav.setAttribute('data-tabs-bound', '');
  var tabs  = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.faq__grp'));

  function show(key, focus){
    tabs.forEach(function(t){
      var on = t.dataset.faq === key;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.faq === key;
      p.hidden = !on;
      /* leave the panel you are switching away from closed up. Coming back to a
         group and finding a panel you opened five minutes ago still hanging open
         reads as a bug, and it makes the two panes different heights. */
      if (!on) [].forEach.call(p.querySelectorAll('details[open]'), function(d){ d.open = false; });
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.faq); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.faq, true);
  });
})();

/* The question groups. Same tablist contract as the four systems — the two could
   share a factory, and if a third tablist ever lands on this page they should.
   Two are not enough to justify the indirection; three would be. */
(function(){
  var nav = document.querySelector('.faq__nav'); if(!nav) return;
  /* one binding per tablist (2026-10-14): see the first copy of this module */
  if (nav.hasAttribute('data-tabs-bound')) return; nav.setAttribute('data-tabs-bound', '');
  var tabs  = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.faq__grp'));

  function show(key, focus){
    tabs.forEach(function(t){
      var on = t.dataset.faq === key;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.faq === key;
      p.hidden = !on;
      /* leave the panel you are switching away from closed up. Coming back to a
         group and finding a panel you opened five minutes ago still hanging open
         reads as a bug, and it makes the two panes different heights. */
      if (!on) [].forEach.call(p.querySelectorAll('details[open]'), function(d){ d.open = false; });
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.faq); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.faq, true);
  });
})();

/* the gallery rail and its script went with the hand-built buy box; the lifted
   section carries a single sticky photograph and needs no JS. */

/* ---- the sticky bar --------------------------------------------------------
   IntersectionObserver on the real CTA, not a scroll listener: the bar should
   appear exactly when the button you would have pressed is off screen, which is
   a visibility question rather than a distance one.
   ⚠ IO delivery rides the rendering steps, so it does not fire in a backgrounded
   tab. That is fine in a real browser and is why this cannot be exercised in the
   preview pane. */
(function(){
  var bar = document.getElementById('stick');
  var cta = document.querySelector('.prod__cta');
  if(!bar || !cta) return;
  [].forEach.call(document.querySelectorAll('[data-jump]'), function(b){
    b.addEventListener('click', function(){ /* the buy column is sticky on desktop, so the button's own rect lies about where it will
         render after the scroll (launch QA, 2026-09-25: from the closing block the page landed
         1129px past the card). Aim at the section, which is static, then focus without scrolling. */
      var sec = document.getElementById('buy'); (sec || cta).scrollIntoView({block:'start'}); cta.focus({preventScroll:true}); });
  });
  if(!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(e){
    var vis = e[0].isIntersecting;
    bar.classList.toggle('is-on', !vis);
    bar.setAttribute('aria-hidden', vis ? 'true' : 'false');
  }, {rootMargin:'0px 0px -40px 0px'}).observe(cta);
})();

/* ---- the menu, below 900px ------------------------------------------------
   ⚠ THE BUTTON IS THE SOURCE OF TRUTH FOR STATE, not a class on the drawer:
   aria-expanded drives both the hamburger's transform and the drawer's [hidden],
   so the thing a screen reader reads and the thing an eye sees cannot disagree.
   ⚠ ESCAPE CLOSES IT AND RETURNS FOCUS to the button. A drawer that traps focus
   with no way back is worse than no drawer.
   ⚠ IT ALSO CLOSES ON RESIZE PAST THE BREAKPOINT. Open the menu on a phone,
   rotate to landscape past 900px, and the drawer would otherwise sit over a nav
   that is already showing its links. */
(function(){
  var btn = document.getElementById('navbtn');
  var draw = document.getElementById('navdraw');
  if (!btn || !draw) return;

  function set(open){
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    draw.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  btn.addEventListener('click', function(){
    set(btn.getAttribute('aria-expanded') !== 'true');
  });
  /* a tap on the drawer's own padding, not on a link, closes it */
  draw.addEventListener('click', function(e){
    if (e.target === draw) set(false);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true'){
      set(false); btn.focus();
    }
  });
  addEventListener('resize', function(){
    if (innerWidth > 900 && btn.getAttribute('aria-expanded') === 'true') set(false);
  });
})();
